const applyButtonDenylist = [
  'Bestseller',
  'Betty - Barclay - DE',
  'Bever',
  'Birkenstock',
  'C&A',
  'C&A - DE',
  'Carhartt',
  'Comma',
  'Daka',
  'Dorothee Schumacher',
  'Falke KG',
  'Gerry Weber',
  'H&M - Belgium',
  'Headhunting for the best',
  'Holy Fashion Group',
  'J-Club International',
  'Jack Wolfskin',
  'Lala Berlin',
  'Liebskind',
  'Loavies',
  'Marc cain',
  'Marco Polo HQ Casual',
  'Marco Polo HQ Denim',
  'Marco Polo Retail',
  'Modepark Rother',
  'Nikkie',
  'Opus',
  'Pandora',
  'Peter Hahn',
  'Remonte',
  'Rich & Royal',
  'Scotch & Soda full layout',
  'Simplicity',
  'Suit Supply',
  'Takko',
  'VF Corporation',
  'VF Dickies',
  'VF Eastpak',
  'VF Kipling',
  'VF Napapijri',
  'VF The North Face',
  'VF Timberland',
  'VF Vans',
  'Willy Bogner',
];

export default applyButtonDenylist;
